<template>
  <a-layout-header
    class="flex items-center justify-between"
    :style="{ height: '48px', padding: '0 16px', background: 'white' }"
  >
    <div class="pl-2.5 flex items-center w-full">
      <Logo />
    </div>
  </a-layout-header>
  <a-spin :spinning="spinning">
    <div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div class="sm:mx-auto sm:w-full sm:max-w-sm">
        <div class="text-xl font-bold text-center text-gray-500">
          {{ $t('Operator selection') }}
        </div>
      </div>

      <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <a-form class="space-y-7" :model="state" @finish="select">
          <div>
            <div class="mt-2">
              <a-form-item name="companyType">
                <a-select
                  v-model:value="state.companyType"
                  @change="
                    state.companyId = null;
                    fetchCompanies();
                  "
                >
                  <a-select-option
                    v-for="companyType in companyTypes"
                    :key="companyType.value"
                    :value="companyType.value"
                  >
                    {{ companyType.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>

          <div>
            <div class="mt-2">
              <a-form-item name="company">
                <a-list
                  class="no-divider-list overflow-y-auto max-h-[382px]"
                  size="small"
                  bordered
                  :data-source="companies"
                  v-if="companies.length"
                >
                  <template #renderItem="{ item }">
                    <a-list-item
                      class="hover:bg-[#DDEBF7] hover:rounded-md hover:cursor-pointer h-[38px]"
                      :class="{
                        'bg-[#DDEBF7]': item.id === state.companyId
                      }"
                      @click="handleSelection(item.id)"
                      @dblclick="
                        handleSelection(item.id);
                        select();
                      "
                      >{{ item.name }}</a-list-item
                    >
                  </template>
                </a-list>
              </a-form-item>
            </div>
          </div>

          <div>
            <a-button
              type="primary"
              html-type="submit"
              class="flex w-full justify-center login-but"
            >
              {{ $t('select') }}
            </a-button>
          </div>
        </a-form>
      </div>
    </div>
  </a-spin>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import Logo from '@/components/Logo.vue';
import { useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import { useAuthStore, useCommonStore } from '@/stores';
import { getWasteCompanies, getTransportCompanies, getAuthTokenForCompany } from '@/services';
import { useI18n } from 'vue-i18n';

const authStore = useAuthStore();
const commonStore = useCommonStore();
const spinning = ref(false);
const { t } = useI18n();
const router = useRouter();
const state = ref({
  companyType: 'transport',
  companyId: null
});

const companyTypes = [
  { label: '排出事業者', value: 'waste' },
  { label: '運搬処分事業者', value: 'transport' }
];

const companies = ref([] as any);

const fetchCompanies = async () => {
  if (state.value.companyType === 'waste') {
    companies.value = (await getWasteCompanies()) as any;
  } else {
    companies.value = (await getTransportCompanies()) as any;
  }
  state.value.companyId = companies.value[0]?.id || null;
};

fetchCompanies();

const select = async () => {
  if (state.value.companyId) {
    try {
      spinning.value = true;
      const isTransport = state.value.companyType === 'transport';
      const res = (await getAuthTokenForCompany(state.value.companyId, isTransport)) as any;
      await authStore.updateToken(res.token);
      commonStore.selectedCompanyId = 'ALL';
      // Lấy đường dẫn muốn đến (nếu có)
      const redirectPath = router.currentRoute.value.redirectedFrom?.fullPath;
      // Lấy đường dẫn hiện tại
      const currentPath = router.currentRoute.value.fullPath;

      // Chỉ 'push' nếu có đường dẫn chuyển hướng,
      // VÀ đường dẫn đó KHÁC với đường dẫn hiện tại
      if (redirectPath && redirectPath !== currentPath) {
        await router.push(redirectPath);
      } else {
        // Nếu không (hoặc nếu 2 đường dẫn bằng nhau),
        // thì đẩy về trang chủ làm fallback
        await router.push('/');
      }
    } catch (e) {
      message.error(t('MSG_00_01'));
    } finally {
      spinning.value = false;
    }
  }
};

/**
 * Handles selection changes to detect double-clicks.
 * @param {any} value - The newly selected value.
 */
const handleSelection = async (value: any) => {
  state.value.companyId = value;
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.min-h-screen {
  background-color: white;
}

.login-but {
  background-color: $blue-color;
}
</style>

<style lang="scss">
.no-divider-list {
  .ant-list-item {
    border-block-end: none !important;
  }
}
</style>
